import React, { useEffect } from 'react'
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { Form, Row, Container, FloatingLabel, Tabs, Tab, Button } from 'react-bootstrap'
import TrainingProviderForm from './TrainingProviderForm';
import * as apiUtility from "../../config/APIUtils";
import TrainingProviderDetails from './TrainingProviderDetails';
import { Box, ListItem, Sheet, Stack } from '@mui/joy';
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import { useUser } from '../../config/UserContext';

function TrainingProvider() {
    //const [value, setValue] = React.useState(0);
    const [trainingProviders, setTrainingProviders] = React.useState([]);
    const [selectedTpObj, setSelectedTpObj] = React.useState({});

    // const handleChange = (event, newValue) => {
    //     setValue(newValue);
    // };
    
    useEffect(() => {
        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "course/fetch-all-training-providers";
        apiUtility.fetchAPIDataGET(apiRequest).then(res => {
            setTrainingProviders(res.data)
        }).catch((error) => console.error(error));
    }, []);
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`vertical-tabpanel-${index}`}
                aria-labelledby={`vertical-tab-${index}`}
                style={{ "width": "100%" }}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    // function a11yProps(index) {
    //     return {
    //         id: `vertical-tab-${index}`,
    //         'aria-controls': `vertical-tabpanel-${index}`,
    //     };
    // }

    const changeTrainingProv = (tpId) => {
        let tpBody = trainingProviders.filter((s) => s.tp_id === parseInt(tpId));
        setSelectedTpObj(tpBody[0]);
    }

    const addNewTp = () => {
        const intialState = {
            tp_id: '',
            provider_name: '',
            primary_contact: {
                status: false,
                first_name: '',
                last_name: '',
                email_id: '',
                user_id: ''
            },
            email: '',
            number: '',
            address: '',
            student_number_regex: '',
            student_number_length: '',
            student_number_check: false
        }
        setSelectedTpObj(intialState);
    }


    return (
        <Container fluid>
            <Box sx={{ mx: "auto", p: 2 }}>
                <Sheet variant='outlined' color='primary' sx={{ p: 2, mb: 1, borderRadius: "md" }}>
                    <Sheet variant="soft" color="primary" sx={{ p: 2, mb: 1, borderRadius: "md", display: "flex" }}>
                        <Stack direction={"row"} sx={{ width: "100%" }}>
                            <Stack direction="column" sx={{ width: "100%", justifyContent: "flex-start", alignItems: "center" }}>
                                <FloatingLabel style={{ width: "500px" }} controlId="floatingTrainingProvider" label=" Training Provider" >
                                    <Form.Select aria-label="Floating label select Training Provider" onChange={(e) => { changeTrainingProv(e.target.value) }}>
                                        <option value=""> -- Please select Training Provider --  </option>
                                        {trainingProviders?.map((data, id) => (
                                            <option value={data.tp_id} key={data.tp_id}>{data.provider_name}</option>
                                        ))}
                                    </Form.Select>
                                </FloatingLabel>
                            </Stack>
                            <Stack direction="column" gap={3} sx={{ width: "100%", justifyContent: "flex-end", alignItems: "center" }}>
                                <ListItem>
                                    <Button variant="warning" style={{ alignContent: "center", alignItems: "center" }} onClick={addNewTp}><LocalLibraryOutlinedIcon sx={{ fontSize: "1.3rem" }} />&nbsp;Add Training Provider</Button>
                                </ListItem>
                            </Stack>
                        </Stack>
                    </Sheet>
                    <br></br>
                    <Row>

                        <Tabs defaultActiveKey="overview" fill className="mb-3" >
                            <Tab eventKey="overview" title="Overview">
                                <TrainingProviderForm data={selectedTpObj} />
                            </Tab>
                            <Tab eventKey="details" title="Course Details">
                                <TrainingProviderDetails data={selectedTpObj} />
                            </Tab>
                        </Tabs>
                    </Row>
                </Sheet>
            </Box>
        </Container>
    )
}

export default TrainingProvider